import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../../../locales/en.json';
import mr from '../../../locales/mr.json';
import hi from '../../../locales/hi.json';

const LANGUAGE_KEY = 'app_language';
const SUPPORTED = ['en', 'mr', 'hi'];

const getSavedLanguage = (): string => {
  try {
    const saved = localStorage.getItem(LANGUAGE_KEY);
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch {}
  return 'mr';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    mr: { translation: mr },
    hi: { translation: hi },
  },
  lng: getSavedLanguage(),
  fallbackLng: 'en',
  initImmediate: false,
  interpolation: { escapeValue: false },
});

// Persist every language change to localStorage
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(LANGUAGE_KEY, lng);
  } catch {}
});

export default i18n;
